import Ajv, { ErrorObject, SchemaObject } from 'ajv'

class ValidationError extends Error {
  constructor(message: string) {
    super(`Validation error: ${message}`)
  }
}

class JsonSchemaValidationError extends Error {
  readonly errors: ErrorObject[]

  constructor(errors: ErrorObject[]) {
    super(`JSON Schema validation failed: ${JSON.stringify(errors)}`)
    this.errors = errors
  }
}

/**
 * Generically asserts that an input value is not nullish and matches the given given JSON Schema
 * @param input
 * @param schema
 */
export function validateAgainstSchema(input: unknown, schema: SchemaObject): void {
  const typeName = schema.$id ?? 'expected type'

  if (input === undefined) {
    throw new ValidationError(`${typeName} is undefined`)
  }

  if (input === null) {
    throw new ValidationError(`${typeName} is null`)
  }

  const validator = new Ajv()
  const result = validator.validate(schema, input as any)

  if (!result) {
    throw new JsonSchemaValidationError(validator.errors ?? [])
  }
}

export function assertUnknown(input: unknown): asserts input is unknown {
  // always valid
}